import { StreamSelectorBase } from './StreamSelectorBase';

export class Stabilizer {
    private avoidUnstableCount = 0;

    get count() {
        return this.avoidUnstableCount;
    }

    get exhausted(): boolean {
        if (this.avoidUnstableCount === 0) {
            return true;
        }

        this.avoidUnstableCount--;
        return false;
    }

    reset(): void {
        this.avoidUnstableCount = 5;
    }
}

export class StreamSelectorStabilizer extends StreamSelectorBase {
    constructor(private stabilizer: Stabilizer) {
        super();
    }

    label() {
        return 'stabilizer';
    }

    description() {
        return this.stabilizer.exhausted
            ? { reason: 'counter exhausted' }
            : { counter: this.stabilizer.count }
            ;
    }

    batchUpdate(): void {
        // not affected
    }

    get(): number | 'matched' | 'deferred' {
        return this.stabilizer.exhausted ? 'matched' : 'deferred';
    }
}
